import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=117889dc&scoped=true&"
import script from "./pay.vue?vue&type=script&lang=js&"
export * from "./pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117889dc",
  null
  
)

export default component.exports